<!--
 * @Description: 关于我们：公司简介
 * @Author: pliybird
 * @Date: 2022-01-30 00:14:48
 * @LastEditTime: 2025-10-23 10:54:39
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <section class="company-container rn-section-gap">
    <div class="container">
      <SectionTitle
        :title="$t('about_us.company_profile.title')"
        description="COMPANY PROFILE"
        textAlign="center"
      />
      <div class="row pb--30 container-top">
        <div
          class="col-lg-6 col-md-6 col-sm-12 col-12 pb--20 pt--50 company-left"
        >
          <div class="company-content-title">
            <div class="company-content-img">
              <img
                class="little-pic"
                src="../../assets/images/aboutUs/title_image.png"
              />
            </div>
            <div class="company-title">
              {{ $t("about_us.company_profile.content.tab01.title") }}
            </div>
          </div>
          <div class="company-p">
            <p class="pt--20 text-indent">
              {{ $t("about_us.company_profile.content.tab01.description") }}
            </p>
            <p class="text-indent pt--20 mt--100">
              {{ $t("about_us.company_profile.content.tab01.desc_hand") }}
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 company-right">
          <!-- PC端地图 -->
          <div class="china-map-container map-pc">
            <img
              src="../../assets/images/aboutUs/china_map.png"
              class="china-map-image"
            />
            <!-- 办公地点标记 -->
            <div
              v-for="(location, index) in locations"
              :key="index"
              :class="['map-marker', { active: activeLocation === index }]"
              :style="{
                top: location.position.top,
                left: location.position.left,
              }"
              @click="showLocationDetail(index)"
              @mouseenter="showLocationDetail(index)"
            >
              <!-- 上海总部使用蓝色星星图标 -->
              <template v-if="index === 0">
                <img
                  src="../../assets/images/aboutUs/blue_star.png"
                  alt="上海总部"
                  class="marker-icon"
                />
              </template>
              <!-- 其他位置根据激活状态显示不同图标 -->
              <template v-else>
                <img
                  :src="
                    activeLocation === index
                      ? require('../../assets/images/aboutUs/yellow_location.png')
                      : require('../../assets/images/aboutUs/gray_location.png')
                  "
                  :alt="location.name"
                  class="marker-icon"
                />
              </template>
              <!-- 城市名称标签 -->
              <div class="city-name">
                {{ getCityName(location.name) }}
              </div>
            </div>
            <!-- 详情对话框 -->
            <div
              v-if="activeLocation !== null"
              :class="['location-dialog', { active: activeLocation !== null }]"
              :style="getDialogStyle(activeLocation)"
            >
              <div class="dialog-header">
                <h4>{{ locations[activeLocation].name }}</h4>
              </div>
              <div class="dialog-content">
                <img
                  :src="locations[activeLocation].image"
                  alt=""
                  class="location-image"
                />
                <div class="location-info">
                  <p class="establish-time">
                    {{ locations[activeLocation].establishTime }}
                  </p>
                  <p class="address">{{ locations[activeLocation].address }}</p>
                </div>
              </div>
              <div class="dialog-arrow"></div>
            </div>
          </div>

          <!-- 移动端地图 -->
          <div class="china-map-container map-mobile">
            <div class="map-mobile-image">
              <img src="../../assets/images/aboutUs/china_map.png" />
              <!-- 移动端地图标记点 -->
              <div
                v-for="(location, index) in locations"
                :key="index"
                :class="['map-marker', { active: mobileActiveTab === index }]"
                :style="{
                  top: location.position.top,
                  left: location.position.left,
                }"
                @click="selectMobileTab(index)"
              >
                <!-- 上海总部使用蓝色星星图标 -->
                <template v-if="index === 0">
                  <img
                    src="../../assets/images/aboutUs/blue_star.png"
                    alt="上海总部"
                    class="marker-icon"
                  />
                </template>
                <!-- 其他位置根据激活状态显示不同图标 -->
                <template v-else>
                  <img
                    :src="
                      mobileActiveTab === index
                        ? require('../../assets/images/aboutUs/yellow_location.png')
                        : require('../../assets/images/aboutUs/gray_location.png')
                    "
                    :alt="location.name"
                    class="marker-icon"
                  />
                </template>
                <!-- 城市名称标签 -->
                <div class="city-name">
                  {{ getCityName(location.name) }}
                </div>
              </div>
            </div>
            <div class="map-mobile-tabs">
              <div
                v-for="(location, index) in locations"
                :key="index"
                :class="['tab-item', { active: mobileActiveTab === index }]"
                @click="selectMobileTab(index)"
              >
                {{ location.name }}
              </div>
            </div>
            <div class="map-mobile-content">
              <div v-if="mobileActiveTab !== null">
                <div class="mobile-location-header">
                  <h4>{{ locations[mobileActiveTab].name }}</h4>
                </div>
                <div class="mobile-location-content">
                  <img
                    :src="locations[mobileActiveTab].image"
                    alt=""
                    class="mobile-location-image"
                  />
                  <div class="mobile-location-info">
                    <p class="establish-time">
                      {{ locations[mobileActiveTab].establishTime }}
                    </p>
                    <p class="address">
                      {{ locations[mobileActiveTab].address }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rwt-counterup-area relative pb--50" style="z-index: 2">
        <div class="container">
          <Counter
            :counter-style="5"
            text-align="center"
            column="col-lg-3 col-md-6 col-sm-6 col-12"
          />
        </div>
      </div>
      <div class="">
        <div class="company-content-title">
          <div class="company-content-img">
            <img
              class="little-pic"
              src="../../assets/images/aboutUs/title_image.png"
            />
          </div>
          <div class="company-title">
            {{ $t("about_us.company_profile.content.tab02.title") }}
          </div>
        </div>
        <div class="company-p ptb--20">
          <p class="text-indent">
            {{ $t("about_us.company_profile.content.tab02.desc1") }}
          </p>
          <p>{{ $t("about_us.company_profile.content.tab02.desc2") }}</p>
          <p>{{ $t("about_us.company_profile.content.tab02.desc3") }}</p>
        </div>
        <img src="../../assets/images/aboutUs/product.png" alt="" />
      </div>
      <div class="pt--30">
        <div class="company-content-title">
          <div class="company-content-img">
            <img
              class="little-pic"
              src="../../assets/images/aboutUs/title_image.png"
            />
          </div>
          <div class="company-title">
            {{ $t("about_us.company_profile.content.tab03.title") }}
          </div>
        </div>
        <div class="company-p ptb--20">
          <p class="text-indent">
            {{ $t("about_us.company_profile.content.tab03.description") }}
          </p>
        </div>
        <div>
          <company-map />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import Counter from "@/components/elements/counterUp/Counter";
import CompanyMap from "./companyMap.vue";
export default {
  name: "CompanyProfile",
  components: { SectionTitle, Counter, CompanyMap },
  data() {
    return {
      curPage: 1,
      activeLocation: 0, // 默认显示上海总部（索引0）
      mobileActiveTab: 0,
      autoShowTimer: null,
      locations: [
        {
          name: "上海总部",
          position: { top: "45%", left: "85%" },
          dialogStyle: { left: "-180px", top: "-10px" },
          image: require("../../assets/images/aboutUs/address/shanghai.jpg"),
          establishTime: "成立时间：2015年3月",
          address: "地址：上海市青浦区汇联路33号",
        },
        {
          name: "西安远程开发中心",
          position: { top: "43%", left: "63%" },
          dialogStyle: { left: "-180px", top: "-10px" },
          image: require("../../assets/images/aboutUs/address/xian_center.jpg"),
          establishTime: "成立时间：2019年7月",
          address: "地址：陕西省西安市雁塔区天谷八路西安环普科技产业园G4座5层",
        },
        {
          name: "武汉远程开发中心",
          position: { top: "47%", left: "71%" },
          dialogStyle: { left: "-180px", top: "-10px" },
          image: require("../../assets/images/aboutUs/address/wuhan_center.jpg"),
          establishTime: "成立时间：2021年6月",
          address: "地址：湖北省武汉市洪山区光谷软件园六期E5栋",
        },
        {
          name: "长沙远程开发中心",
          position: { top: "53%", left: "67%" },
          dialogStyle: { left: "-180px", top: "-10px" },
          image: require("../../assets/images/aboutUs/address/changsha_center.jpg"),
          establishTime: "成立时间：2021年7月",
          address:
            "地址：湖南省长沙市芙蓉区万家丽中路99号万家丽国际mall第13楼1301-1号A区A045",
        },
        {
          name: "郑州远程开发中心",
          position: { top: "40%", left: "72%" },
          dialogStyle: { left: "-180px", top: "-10px" },
          image: require("../../assets/images/aboutUs/address/zhengzhou_center.jpg"),
          establishTime: "成立时间：2021年9月",
          address:
            "地址：河南省郑州市高新技术产业开发区玉兰大厦A座504(玉兰街与月桂路交叉口西120米)",
        },
        {
          name: "常州远程开发中心",
          position: { top: "42%", left: "81%" },
          dialogStyle: { left: "-180px", top: "-10px" },
          image: require("../../assets/images/aboutUs/address/changzhou_center.jpg"),
          establishTime: "成立时间：2021年8月",
          address: "地址：江苏省常州市武进区科教城三艾科技大厦6A17室",
        },
        {
          name: "印尼远程开发中心",
          position: { top: "82%", left: "58%" },
          dialogStyle: { left: "-180px", top: "-280px" },
          image: require("../../assets/images/aboutUs/address/indonesia_center.jpg"),
          establishTime: "成立时间：2024年12月",
          address:
            "地址：Tatapuri Building, Jl. Tanjung Karang No.3-4A Lt. 2, Kb. Melati, Kecamatan Tanah Abang, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta 10230 Indonesia",
        },
        {
          name: "大连远程开发中心",
          position: { top: "25%", left: "86%" },
          dialogStyle: { left: "-180px", top: "10px" },
          image: require("../../assets/images/aboutUs/address/shanghai.jpg"),
          establishTime: "成立时间：2025年2月",
          address: "",
        },
      ],
    };
  },
  methods: {
    // 提取城市名称
    getCityName(fullName) {
      // 从完整名称中提取城市名（取第一个中文字符或印尼）
      if (fullName.includes("上海")) return "上海";
      if (fullName.includes("西安")) return "西安";
      if (fullName.includes("武汉")) return "武汉";
      if (fullName.includes("长沙")) return "长沙";
      if (fullName.includes("郑州")) return "郑州";
      if (fullName.includes("常州")) return "常州";
      if (fullName.includes("印尼")) return "印尼";
      if (fullName.includes("大连")) return "大连";
      return fullName;
    },

    showLocationDetail(index) {
      this.activeLocation = index;
      // 移动端同步更新选中状态
      this.mobileActiveTab = index;
      // 添加点击外部关闭对话框的逻辑
      setTimeout(() => {
        document.addEventListener("click", this.handleOutsideClick);
      }, 0);
    },
    handleOutsideClick(event) {
      const container = event.target.closest(".china-map-container");
      if (!container) {
        this.activeLocation = null;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    getDialogStyle(index) {
      // 获取标记点位置
      const markerPosition = this.locations[index].position;

      // 始终将对话框定位在标记点左侧，避免遮挡
      let additionalClasses = "";

      // 解析位置百分比
      const topPercent = parseFloat(markerPosition.top);
      const leftPercent = parseFloat(markerPosition.left);

      // 当标记点靠近底部时，调整垂直位置
      if (topPercent > 70) {
        additionalClasses += "adjust-bottom";
      }

      // 当标记点靠近左侧时，需要特殊处理避免超出边界
      if (leftPercent < 30) {
        additionalClasses += " adjust-right";
      }

      // 应用额外的类到对话框
      if (this.activeLocation === index) {
        setTimeout(() => {
          const dialog = document.querySelector(".location-dialog");
          if (dialog) {
            dialog.className = `location-dialog active ${additionalClasses.trim()}`;
          }
        }, 0);
      }

      // 返回基础样式，将对话框定位在标记点左侧
      return {
        top: markerPosition.top,
        left: markerPosition.left,
        transform: "translate(-100%, -50%)", // 定位在标记点左侧
      };
    },
    // 初始化自动循环显示功能
    initAutoShow() {
      // 清除之前的定时器（如果存在）
      if (this.autoShowTimer) {
        clearInterval(this.autoShowTimer);
      }

      // 从上海总部（索引0）开始，每6秒依次循环显示各个位置
      let currentIndex = 1; // 下一个要显示的索引，从1开始，因为初始已经显示0
      this.autoShowTimer = setInterval(() => {
        // 如果用户没有手动交互（鼠标悬停或点击），则自动切换
        if (!document.querySelector(".map-marker:hover")) {
          this.showLocationDetail(currentIndex);
          currentIndex = (currentIndex + 1) % this.locations.length;
        }
      }, 6000);
    },
    // 移动端tab点击时滚动到居中位置并更新地图标记
    selectMobileTab(index) {
      this.mobileActiveTab = index;
      // 等待DOM更新后滚动
      this.$nextTick(() => {
        const tabsContainer = document.querySelector(".map-mobile-tabs");
        const activeTab = tabsContainer.querySelector(".tab-item.active");
        if (activeTab) {
          // 计算滚动位置，使激活的tab居中
          const containerWidth = tabsContainer.clientWidth;
          const tabLeft = activeTab.offsetLeft;
          const tabWidth = activeTab.offsetWidth;
          const scrollPosition = tabLeft - containerWidth / 2 + tabWidth / 2;

          // 平滑滚动
          tabsContainer.scrollTo({
            left: scrollPosition,
            behavior: "smooth",
          });
        }
      });
    },
  },
  mounted() {
    // 仅在PC端启动自动循环显示，移动端不需要
    this.$nextTick(() => {
      // 简单检测是否为移动端
      const isMobile = window.innerWidth <= 768;
      if (!isMobile) {
        this.initAutoShow();
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
    // 清除定时器
    if (this.autoShowTimer) {
      clearInterval(this.autoShowTimer);
    }
  },
};
</script>
<style lang="scss" scoped>
.china-map-container {
  position: relative;
  width: 100%;
  min-height: 400px;
  margin: 0 auto;
  cursor: pointer;
}

/* PC端地图样式 */
.map-pc,
.map-mobile {
  .china-map-image {
    width: 100%;
    height: auto;
    display: block;
    position: relative;
  }

  .map-marker {
    position: absolute;
    transform: translate(-50%, -50%);
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      z-index: 10;
    }

    &.active {
      z-index: 15;
    }

    .marker-icon {
      width: 24px;
      height: 24px;
      object-fit: contain;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }

    .city-name {
      position: absolute;
      top: 100%;
      margin-top: 4px;
      font-size: 12px;
      color: #333;
      background: rgba(255, 255, 255, 0.9);
      padding: 2px 6px;
      border-radius: 4px;
      white-space: nowrap;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    &.active .city-name {
      color: #1457df;
      font-weight: bold;
    }
  }
}

/* 单独的PC端地图样式补充 */
.map-pc {
  .map-marker {
    position: absolute;
    transform: translate(-50%, -50%);
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      z-index: 10;
    }

    &.active {
      z-index: 15;
    }

    .marker-icon {
      width: 24px; /* 略微增大图标尺寸以更好显示图片内容 */
      height: 24px;
      object-fit: contain;
      transition: all 0.3s ease;

      /* 为图片添加一些悬停效果 */
      &:hover {
        transform: scale(1.1);
      }
    }

    .city-name {
      position: absolute;
      top: 100%;
      margin-top: 4px;
      font-size: 12px;
      color: #333;
      background: rgba(255, 255, 255, 0.9);
      padding: 2px 6px;
      border-radius: 4px;
      white-space: nowrap;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
    }

    /* 激活状态的文字样式 */
    &.active .city-name {
      color: #1457df;
      font-weight: bold;
    }
  }

  .location-dialog {
    position: absolute;
    width: 240px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 12px;
    z-index: 100;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    margin-left: -20px; // 额外向左偏移一些，确保不遮挡标记点

    &.active {
      opacity: 1;
      visibility: visible;
    }

    /* 防止对话框超出视图范围 */
    &.adjust-bottom {
      transform: translate(-100%, 20px) !important; // 调整为左侧显示

      .dialog-arrow {
        border-top: none;
        border-bottom: 8px solid white;
        bottom: auto;
        top: -8px;
        left: auto;
        right: 20px;
      }
    }

    &.adjust-right {
      transform: translate(10px, -50%) !important; // 对于左侧的点，显示在右侧
      margin-left: 0;
      margin-right: -20px;

      .dialog-arrow {
        border-left: none;
        border-right: 8px solid white;
        left: -8px;
        right: auto;
      }
    }

    .dialog-header {
      margin-bottom: 10px;

      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .dialog-content {
      .location-image {
        width: 100%;
        height: 120px;
        object-fit: cover;
        border-radius: 4px;
        margin-bottom: 10px;
      }

      .location-info {
        line-height: 1.6;

        .establish-time {
          color: #33394b;
          font-size: 14px;
          margin-bottom: 5px;
        }

        .address {
          color: #33394b;
          margin: 0;
          font-size: 14px;
        }
      }
    }

    .dialog-arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
      border-left: 8px solid white; // 修改为左侧箭头，指向标记点
      right: -8px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

/* 移动端地图样式 */
.map-mobile {
  display: none;

  .map-mobile-image {
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
  }

  .map-mobile-tabs {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 10px;
    margin-bottom: 20px;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

    /* 隐藏滚动条但保持滚动功能 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    .tab-item {
      display: inline-block;
      padding: 8px 16px;
      margin-right: 10px;
      background: #f5f5f5;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s ease;

      &.active {
        background: #007bff;
        color: white;
      }
    }
  }

  .map-mobile-content {
    .mobile-location-header {
      margin-bottom: 15px;

      h4 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        text-align: center;
      }
    }

    .mobile-location-content {
      .mobile-location-image {
        width: 100%;
        height: 180px;
        object-fit: cover;
        border-radius: 8px;
        margin-bottom: 15px;
      }

      .mobile-location-info {
        font-size: 14px;
        line-height: 1.8;

        .establish-time {
          color: #666;
          margin-bottom: 8px;
          text-align: center;
        }

        .address {
          color: #333;
          margin: 0;
          text-align: center;
          white-space: normal;
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .map-pc {
    display: none;
  }

  .map-mobile {
    display: block;
  }

  .china-map-container {
    min-height: 300px;
  }
}

/* 确保图片资源的默认占位样式 */
.location-image,
.mobile-location-image {
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
}
</style>
